<template>
	<portal to="root">
		<div
			:class="[
				'c-dropcursor',
				position,
				{ centered: isCentered === true },
				{ active: active === true },
			]"
			:style="dropcursorStyle"
		></div>
	</portal>
</template>

<script>
import debounce from '@/lib/debounce.js';
import $ from 'jquery';

export default {
	data: function () {
		return {
			x: 0,
			y: 0,

			offset: 0,

			container: null,
			scrollContainer: null,

			blockId: '',
			hoverEl: null,
			position: 'top',
			isCentered: false,
			active: false,
			type: 'block', //can be block or item
		};
	},

	watch: {
		dataTransfer: function () {
			this.onDatatransfer();
		},
	},

	computed: {
		dropcursorStyle: function () {
			if (!this.hoverEl) {
				let transform = `transform:translateY(${this.offset}px);`;
				return transform;
			}
			let transform = '';
			if (this.type === 'block') {
				let scroll = this.scrollContainer.getBoundingClientRect().top;
				scroll = scroll * -1;
				let rect = this.hoverEl.getBoundingClientRect();
				let offset = rect.bottom; // c-header
				if (this.position === 'top') {
					offset = rect.bottom - rect.height; // c-header
				}

				let acceptDrop = this.hoverEl.dataset.acceptdrop === 'true';

				offset = offset + scroll;
				this.offset = offset;
				let offsetY = offset;
				let offsetX = rect.left;
				offsetY -= 1;
				transform = `transform:translate(${offsetX}px, ${offsetY}px);width:${rect.width}px`;
				if (this.isCentered) {
					transform = `${transform};height:${rect.height}px`;
				}
			} else {
				let scroll = this.scrollContainer.getBoundingClientRect().top;
				scroll = scroll * -1;
				let rect = this.hoverEl.getBoundingClientRect();
				let offsetY = rect.bottom - rect.height;
				let offsetX = rect.left;
				offsetY = offsetY + scroll;
				this.offset = offsetY;
				transform = `transform:translate(${offsetX}px, ${offsetY}px);height:${rect.height}px;width:${rect.width}px`;
			}
			return transform;
		},
		moving: function () {
			return this.$store.getters['dashboard/moving'];
		},
		dataTransfer: function () {
			return this.$store.state.dataTransfer;
		},
	},

	methods: {
		start: function () {
			this.active = true;
			this.$store.commit('dashboard/SET_MOVING', true);
		},
		stop: function () {
			this.active = false;
			this.blockId = '';
			this.$store.commit('dashboard/SET_MOVING', false);
		},
		updateDropcursor: function (mouse, el) {
			if (!mouse) {
				this.stop();
				return;
			}
			if (mouse.x > 0 && mouse.x < window.document.body.offsetWidth) {
			} else {
				return;
			}

			let temp = {
				x: mouse.x,
				y: mouse.y,
			};
			// Intrepret the x axis as being in the center so the user doens't need to purposefully drag inside the renderer
			temp.x = window.document.body.offsetWidth / 2;
			if (!el) {
				el = document.elementFromPoint(temp.x, temp.y);
			}
			let check = $(el).closest('.c-block');
			if (check.length > 0) {
				let rect = check[0].getBoundingClientRect();
				let scrollContainer = $('.hook-container');

				let scroll = scrollContainer[0].getBoundingClientRect().top;
				let midpoint = rect.height / 2 + rect.top + scroll;
				let realMouseY = mouse.y + scroll;
				if (realMouseY > midpoint) {
					// determine if mouse is generally on the top portion of the block or the bottom portion
					this.position = 'bottom';
				} else {
					this.position = 'top';
				}
				let temp = 6; //rect.height / 3;
				//console.log(realMouseY < rect.height + rect.top - temp);
				let acceptDrop = check.data().acceptdrop || false;
				if (
					acceptDrop &&
					realMouseY > rect.top + scroll + temp &&
					realMouseY < rect.top + rect.height + scroll - temp
				) {
					// Determine if mouse is generally in the middle portion of the block
					this.isCentered = true;
					this.position = 'top';
				} else {
					this.isCentered = false;
				}
				this.type = 'block';
				this.hoverEl = check[0];
				return;
			}
			el = document.elementFromPoint(mouse.x, mouse.y);
			let itemEl = $(el).closest('.hook-item');
			if (itemEl.length > 0) {
				this.position = 'top';
				this.hoverEl = itemEl[0];
				this.isCentered = true;
				this.type = 'item';
				return;
			}
		},
		startDrag: function (id) {
			this.blockId = id;
			this.start();
		},
		onMouseMove(e) {
			if (!this.active) {
				return;
			}
			this.x = e.clientX;
			this.y = e.clientY;

			this.updateDropcursor({
				x: e.clientX,
				y: e.clientY,
			});

			// update dropcursor
			// this.$emit('dragging', {
			// 	x: this.x,
			// 	y: this.y,
			// });
		},
		async onMouseUp(e) {
			if (!this.active) {
				return;
			}

			if (this.hoverEl && this.blockId === this.hoverEl.dataset.id) {
				// Don't update position if both blocks are the same
				this.stop();
				return;
			}

			// Move block to the breadcrumb item
			if (this.hoverEl && this.active && this.type === 'item') {
				this.$emit('dragend', {
					type: 'drop',
					currentBlock: this.blockId,
					replacerBlock: this.hoverEl.dataset.id,
					position: this.position,
				});
				this.stop();
				return;
			}

			if (this.hoverEl && this.active) {
				if (this.isCentered) {
					this.$emit('dragend', {
						type: 'drop',
						currentBlock: this.blockId,
						replacerBlock: this.hoverEl.dataset.id,
						position: this.position,
					});
				} else {
					this.$emit('dragend', {
						type: 'swap',
						currentBlock: this.blockId,
						replacerBlock: this.hoverEl.dataset.id,
						position: this.position,
					});
				}

				this.stop();
				return;
			}

			if (!this.hoverEl && this.active) {
				this.stop();
			}
		},
		onDatatransfer: function () {
			if (this.dataTransfer.type === 'drag') {
				if (!this.active) {
					this.start();
				}
				this.updateDropcursor({
					x: this.dataTransfer.mouse.x,
					y: this.dataTransfer.mouse.y,
				});
			}
			if (this.dataTransfer.type === 'dragend') {
				this.stop();
			}
		},
	},

	mounted: function () {
		this.container = $('.c-sheet-view')[0];
		this.scrollContainer = $('#app')[0];
		this.onMouseMoveFx = debounce(this.onMouseMove, 5);
		window.addEventListener('mousemove', this.onMouseMoveFx);
		window.addEventListener('mouseup', this.onMouseUp);
	},

	beforeDestroy: function () {
		window.removeEventListener('mousemove', this.onMouseMoveFx);
		window.removeEventListener('mouseup', this.onMouseUp);
	},
};
</script>

<style lang="scss">
.c-dropcursor {
	position: absolute;
	z-index: var(--z-5);
	top: 0; //-1px;
	left: 0;
	width: 100%;
	border-radius: var(--border-radius-sm);
	height: 2px;
	background-color: var(--p3);
	box-shadow: 0 1px 2px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.25),
		0 2px 6px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.15),
		0 1px 12px 0 rgba(var(--p-r), var(--p-g), var(--p-b), 0.075);
	transition: opacity 200ms ease-out,
		transform 120ms cubic-bezier(0.255, 0.93, 0.64, 1),
		height 120ms cubic-bezier(0.375, 0.005, 0.28, 1), box-shadow 120ms linear,
		background-color 120ms linear;
	opacity: 0;
	pointer-events: none;

	&.top {
		box-shadow: 0 -1px 2px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.25),
			0 -2px 6px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.15),
			0 -1px 12px 0 rgba(var(--p-r), var(--p-g), var(--p-b), 0.075);
	}

	&.active {
		opacity: 1;
	}

	&.centered {
		background-color: rgba(var(--p-r), var(--p-g), var(--p-b), 0.25);
		box-shadow: 0 0px 0 2px rgba(var(--p-r), var(--p-g), var(--p-b), 1),
			0 0px 2px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.25),
			0 0px 6px 1px rgba(var(--p-r), var(--p-g), var(--p-b), 0.15),
			0 0px 12px 0 rgba(var(--p-r), var(--p-g), var(--p-b), 0.075);
	}
}
</style>